import React, { useEffect, useState } from "react";
import { useTranslation } from "../../../context/TranslationContext";
import PersonCount from "./PersonCount";

const Pagefive = ({ formdata, setformdata, validSteps, setvalidSteps }) => {
  const [name, setName] = useState(formdata.name);
  const [email, setEmail] = useState(formdata.email);
  const [phone, setPhone] = useState(formdata.phone);
  const [adult, setAdult] = useState(formdata.adult);
  const [child, setChild] = useState(formdata.child);
  const [infant, setInfant] = useState(formdata.infant);

  useEffect(() => {
    const isValid = name && email && phone && Number(adult) > 0;

    setvalidSteps({ ...validSteps, 5: isValid });
    setformdata({ ...formdata, name, email, phone, adult, child, infant });
  }, [name, email, phone, adult, child, infant]);

  const {
    getOfferStep5Title,
    getOfferFormFullName,
    getOfferFormEmail,
    getOfferFormPhone,
    getOfferFormAdult,
    getOfferFormChild,
    getOfferFormInfant,
  } = useTranslation();
  return (
    <>
      <div className="flex justify-center mb-6">
        <span className="md:text-25 text-15 text-black font-medium">
          {getOfferStep5Title}
        </span>
      </div>
      <div className="grid sm:grid-cols-2 grid-cols-1 sm:gap-5 gap-3">
        <div className="relative z-0 mb-6 w-full group">
          <input
            type="text"
            name="name"
            id="name"
            className="block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border border-gray-300 appearance-none   focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
            placeholder=" "
            value={name}
            onChange={(e) => setName(e.target.value)}
          ></input>
          <label
            htmlFor="name"
            className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form  duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3  left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
          >
            {getOfferFormFullName}
          </label>
        </div>
        <div className="relative z-0 mb-6 w-full group">
          <input
            type="mail"
            name="email"
            id="email"
            className="block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border border-gray-300 appearance-none   focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
            placeholder=" "
            required=""
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></input>
          <label
            htmlFor="email"
            className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
          >
            {getOfferFormEmail}
          </label>
        </div>
        <div className="relative z-0 mb-6 w-full group">
          <input
            type="number"
            name="phone"
            id="phone"
            className="block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
            placeholder=" "
            required=""
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          ></input>
          <label
            htmlFor="phone"
            className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-reervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
          >
            {getOfferFormPhone}
          </label>
        </div>
        <PersonCount
          name="adult"
          person={adult}
          setPerson={setAdult}
          placeholder={getOfferFormAdult}
        />
        <PersonCount
          name="child"
          person={child}
          setPerson={setChild}
          placeholder={getOfferFormChild}
        />
        <PersonCount
          name="infant"
          person={infant}
          setPerson={setInfant}
          placeholder={getOfferFormInfant}
        />
        {/* <div className="relative z-0 mb-6 w-full group">
          <select
            value={person}
            onChange={(e) => setPerson(e.target.value)}
            className="block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border border-gray-300 appearance-none   focus:outline-none focus:ring-0 focus:border-[#EC7823] peer"
          >
            <option value="">{getOfferFormPerson}</option>
            {Array.from({ length: 20 }, (v, i) => i + 1).map((v, key) => (
              <option key={key} value={v}>
                {v}
              </option>
            ))}
          </select>
        </div> */}
      </div>
    </>
  );
};

export default Pagefive;
